import { supportConstants } from "../Constants/supportConstant";

const initialValues = {
  isLoading: false,
  isThreadLoading: false,
  tickets: [],
  ticket_detailed: {},
  thread: [],
  stats: {},
  agents: [],
  member360: {},
  memberTickets: [],
  reports: {},
  response: {
    state: null,
    message: "",
  },
};

const supportReducer = (state = initialValues, action) => {
  switch (action.type) {
    case supportConstants.LOADING:
      return { ...state, isLoading: action.isLoading };
    case supportConstants.THREAD_LOADING:
      return { ...state, isThreadLoading: action.isLoading };
    case supportConstants.GET_TICKETS:
      return { ...state, tickets: action.payload.tickets };
    case supportConstants.GET_TICKET_DETAILED:
      return { ...state, ticket_detailed: action.payload.ticket };
    case supportConstants.GET_TICKET_THREAD:
      return { ...state, thread: action.payload.thread };
    case supportConstants.GET_STATS:
      return { ...state, stats: action.payload.stats };
    case supportConstants.GET_AGENTS:
      return { ...state, agents: action.payload.agents };
    case supportConstants.GET_MEMBER_360:
      return { ...state, member360: action.payload.member360 };
    case supportConstants.GET_MEMBER_TICKETS:
      return { ...state, memberTickets: action.payload.memberTickets };
    case supportConstants.GET_REPORTS:
      return { ...state, reports: action.payload.reports };
    // Detail view is remounted per ticket; clearing on unmount stops the
    // previous ticket's thread flashing while the next one loads.
    case supportConstants.CLEAR_TICKET_DETAILED:
      return { ...state, ticket_detailed: {}, thread: [], member360: {} };
    case supportConstants.RESPONSE:
      return {
        ...state,
        response: {
          state: action.response.state,
          message: action.response.message,
        },
      };
    default:
      return state;
  }
};

export default supportReducer;
